import { render, staticRenderFns } from "./general_report_by_flat_by_service_legacy.vue?vue&type=template&id=2c5fde51&scoped=true&"
import script from "./general_report_by_flat_by_service_legacy.vue?vue&type=script&lang=js&"
export * from "./general_report_by_flat_by_service_legacy.vue?vue&type=script&lang=js&"
import style0 from "./general_report_by_flat_by_service_legacy.vue?vue&type=style&index=0&id=2c5fde51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5fde51",
  null
  
)

export default component.exports